import type { NativeStackNavigationOptions } from '@react-navigation/native-stack'

export const getStackHeaderOptions = (
  presentation: NativeStackNavigationOptions['presentation'] = 'containedTransparentModal'
) =>
  ({
    presentation,
    headerShown: false,
    contentStyle: {
      backgroundColor: 'transparent',
      position: 'relative',
      zIndex: 1,
    },
  }) satisfies NativeStackNavigationOptions
